import { useEffect, useState } from "react";
import { Plus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { LISTA_TIPOS } from "../lib/catalogs";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../components/ui/select";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../components/ui/dialog";

export default function ListasNegras() {
    const [rows, setRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ tipo_lista: "pep", nombre: "", rfc: "", curp: "", alias: "", fuente: "" });
    const [busy, setBusy] = useState(false);

    const load = async () => {
        try {
            const { data } = await api.get("/listas-negras");
            setRows(data);
        } catch (err) {
            toast.error("Sin acceso", { description: err?.response?.data?.detail });
        }
    };
    useEffect(() => {
        load();
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/listas-negras", form);
            toast.success("Registro agregado a la lista");
            setOpen(false);
            setForm({ tipo_lista: "pep", nombre: "", rfc: "", curp: "", alias: "", fuente: "" });
            load();
        } catch (err) {
            toast.error("Error", { description: err?.response?.data?.detail });
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="p-8 lg:p-10 space-y-6 max-w-[1400px]" data-testid="listas-negras-page">
            <div className="flex items-start justify-between gap-6">
                <div>
                    <div className="text-[11px] uppercase tracking-[0.3em] text-[color:var(--brand-dark-gold)] font-semibold mb-2">
                        Cumplimiento
                    </div>
                    <h1 className="font-display text-4xl tracking-tight">Listas negras</h1>
                    <p className="text-sm text-muted-foreground mt-1">
                        PEP · OFAC · Interpol · listas nacionales.{" "}
                        <span className="badge-mock">MOCK</span> — se sustituyen por integración real
                        posterior.
                    </p>
                </div>
                <Dialog open={open} onOpenChange={setOpen}>
                    <DialogTrigger asChild>
                        <Button data-testid="add-lista-btn"><Plus className="h-4 w-4 mr-2" /> Agregar</Button>
                    </DialogTrigger>
                    <DialogContent>
                        <DialogHeader>
                            <DialogTitle>Agregar a lista negra</DialogTitle>
                        </DialogHeader>
                        <form onSubmit={submit} className="space-y-3" data-testid="add-lista-form">
                            <div>
                                <Label>Tipo</Label>
                                <Select value={form.tipo_lista} onValueChange={(v) => setForm({ ...form, tipo_lista: v })}>
                                    <SelectTrigger><SelectValue /></SelectTrigger>
                                    <SelectContent>
                                        {LISTA_TIPOS.map((t) => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}
                                    </SelectContent>
                                </Select>
                            </div>
                            <div>
                                <Label>Nombre</Label>
                                <Input required value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} data-testid="lista-nombre" />
                            </div>
                            <div className="grid grid-cols-2 gap-3">
                                <div><Label>RFC</Label><Input value={form.rfc} onChange={(e) => setForm({ ...form, rfc: e.target.value })} /></div>
                                <div><Label>CURP</Label><Input value={form.curp} onChange={(e) => setForm({ ...form, curp: e.target.value })} /></div>
                            </div>
                            <div><Label>Alias</Label><Input value={form.alias} onChange={(e) => setForm({ ...form, alias: e.target.value })} /></div>
                            <div><Label>Fuente</Label><Input value={form.fuente} onChange={(e) => setForm({ ...form, fuente: e.target.value })} /></div>
                            <DialogFooter>
                                <Button type="submit" disabled={busy} data-testid="submit-lista">
                                    {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Agregar"}
                                </Button>
                            </DialogFooter>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>

            <div className="rounded-md border border-border overflow-hidden bg-card">
                <table className="trf-table" data-testid="listas-negras-table">
                    <thead>
                        <tr>
                            <th>Tipo</th>
                            <th>Nombre</th>
                            <th>RFC</th>
                            <th>Alias</th>
                            <th>Fuente</th>
                            <th>Ingreso</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r) => (
                            <tr key={r.id}>
                                <td><span className="badge-mock">{r.tipo_lista}</span></td>
                                <td className="font-medium">{r.nombre}</td>
                                <td className="tabular text-xs">{r.rfc || "—"}</td>
                                <td className="text-xs">{r.alias || "—"}</td>
                                <td className="text-xs">{r.fuente || "—"}</td>
                                <td className="text-[11px] tabular">{r.fecha_ingreso?.slice(0, 10)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
